import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ReservationPriority } from './reservation-priority.model';
import { ReservationPriorityService } from './reservation-priority.service';
@Injectable()
export class ReservationPriorityPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private router: Router,
        private reservationPriorityService: ReservationPriorityService

    ) { }

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.reservationPriorityService.find(id).subscribe(reservationPriority => {
                this.reservationPriorityModalRef(component, reservationPriority);
            });
        } else {
            setTimeout(() => {
                // the setTimeout is needed to avoid ExpressionChangedAfterItHasBeenCheckedError error in dev mode
                return this.reservationPriorityModalRef(component, new ReservationPriority());
            });
        }
    }

    reservationPriorityModalRef(component: Component, reservationPriority: ReservationPriority): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.reservationPriority = reservationPriority;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority-popup.service.ts